import { AfterViewInit, Component, DoCheck, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Log } from "ng2-logger";
import { Tool } from "../../model/tool.model";
import { AppUtils } from "../../../shared/util/app.utils";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Ticket } from "../../../shared/models/ticket.model";
import { WizardModalComponent } from "../../../shared/components/wizard-modal/wizard-modal.component";
import { OperationType } from "../../model/operationType.model";
import { ToastsManager } from "@app/shared/util/toastr.service";
import { TranslateService } from '@ngx-translate/core';
import { ToolScanTreeComponent } from '..';


@Component({
    selector: 'app-confirm-delete-modal',
    templateUrl: './confirm-delete-modal.component.html',
    styleUrls: ['./confirm-delete-modal.component.scss']
})
export class ConfirmDeleteModalComponent implements OnChanges {
    _logger = Log.create(ConfirmDeleteModalComponent.name);

    @ViewChild(WizardModalComponent, {static: true}) modal: WizardModalComponent;
    @ViewChild(ToolScanTreeComponent, {static: true}) toolScanTree: ToolScanTreeComponent;

    @Input() selectedTool: Tool;
    @Input() showValidations = false;
    @Input() scannedTools = [];
    @Input() isToolSet = false;

    @Output() confirmDelete: EventEmitter<any> = new EventEmitter();

    public ticket: Ticket = new Ticket();

    selectToolsForm: UntypedFormGroup;
    reasonForm: UntypedFormGroup;

    selectedTools: any = [];
    operationTypes: OperationType[] = [];

    isScanListenerActive = false;

    constructor(private toastr: ToastsManager,
                private translationService: TranslateService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.onFormInit();
    }

    open() {
        this.isScanListenerActive = true;
        this.onFormInit();
        this.modal.open();
    }

    close() {
        this.isScanListenerActive = false;
        this.modal.close();
        this.resetForm();
    }


    onFormInit() {
        this.selectToolsForm = new UntypedFormGroup({
            'selectedTools': new UntypedFormControl(this.selectedTools, [AppUtils.toolHasToBeSelected(this.scannedTools.length)])
        });

        this.reasonForm = new UntypedFormGroup({
            'deleteReason': new UntypedFormControl(this.selectedTools, Validators.required)
        });

    }

    onStepChange(step) {
        this._logger.info('onStepChange:: ', step);
    }

    onCancel() {
        this.isScanListenerActive = false;
        this.resetForm();
        this.modal.close();
    }

    onSubmit() {
        this._logger.info('createTicket:: Form is valid', this.selectToolsForm);
        if (!this.isFormValid()) {
            return;
        }

        const formValue = Object.assign(
            {
                toolId: this.selectedTool ? this.selectedTool.id : this.scannedTools[0].id,
                isSet: this.isToolSet
            }, this.reasonForm.value);

        this.confirmDelete.emit(formValue);
        this.close();
    }

    resetForm() {
        this.selectToolsForm.reset();
        this._logger.info('resetForm:: Resetting form');
        this.showValidations = false;
        this.modal.reset();
        this.selectedTools = [];
    }

    onItemNotFound(event) {
        this.toastr.warning(this.toolScanInvalid(event));
    }

    private toolScanInvalid(uid) {
        return this.translationService.instant('tree.toolSelect.toasts.notPartOfSet', {uid: uid});
    }

    private isFormValid() {
        this.showValidations = true;
        return this.reasonForm.valid;
    }
}
